import { render } from "./distributor_vehicles_form.vue?vue&type=template&id=57f3803f&scoped=true"
import script from "./distributor_vehicles_form.vue?vue&type=script&lang=js"
export * from "./distributor_vehicles_form.vue?vue&type=script&lang=js"

import "./distributor_vehicles_form.vue?vue&type=style&index=0&id=57f3803f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f3803f"]])

export default __exports__